import axios from 'axios';
import { transformKeys } from './transform';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Send httpOnly cookies with every request
});

// Transform snake_case response keys to camelCase, and handle 401 responses
api.interceptors.response.use(
  (response) => {
    if (response.data) {
      response.data = transformKeys(response.data);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Public endpoints must never bounce the user to /login. The auth-check
      // 401 is expected for logged-out users, and the scorer (security-scan,
      // detect) is usable without an account, so a 401 there is handled inline.
      const url = error.config?.url || '';
      const PUBLIC_ENDPOINTS = ['/auth/me', '/security-scan', '/skills/detect'];
      const isPublic = PUBLIC_ENDPOINTS.some((p) => url === p || url.endsWith(p));
      if (!isPublic && window.location.pathname !== '/login' && !window.location.pathname.startsWith('/auth/')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
